module.exports = __webpack_public_path__ + "img/theme4.ffa76edf.png";